import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import type { App } from 'vue'
import { Layout } from '@/utils/routerHelper'
import { useI18n } from '@/hooks/web/useI18n'
import { fa } from '@faker-js/faker'

const { t } = useI18n()

export const constantRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard/welcome',
    name: 'Root',
    meta: {
      hidden: true
    }
  },
  {
    path: '/dashboard',
    component: Layout,
    name: 'Dashboard',
    meta: {
      title: '仪表盘',
      icon: 'carbon:skill-level-advanced',
      hidden: true,
      affix: false
    },
    children: [
      {
        path: 'welcome',
        name: 'Welcome',
        component: () => import('@/views/dashboard/welcome/index.vue'),
        meta: {
          title: '欢迎',
          icon: 'carbon:skill-level-advanced',
          hidden: true,
          affix: false
        }
      }
    ]
  },
  {
    path: '/redirect',
    component: Layout,
    name: 'Redirect',
    children: [
      {
        path: '/redirect/:path(.*)',
        name: 'Redirect',
        component: () => import('@/views/Redirect/Redirect.vue'),
        meta: {}
      }
    ],
    meta: {
      hidden: true,
      noTagsView: true
    }
  },
  {
    path: '/login',
    component: () => import('@/views/Login/Login.vue'),
    name: 'Login',
    meta: {
      hidden: true,
      title: t('router.login'),
      noTagsView: true
    }
  },
  {
    path: '/404',
    component: () => import('@/views/Error/404.vue'),
    name: 'NoFind',
    meta: {
      hidden: true,
      title: '404',
      noTagsView: true
    }
  }
]

export const asyncRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/goods',
    component: Layout,
    redirect: '/goods/enter-review',
    name: 'Goods',
    meta: {
      title: '商品',
      icon: 'carbon:skill-level-advanced'
    },
    children: [
      {
        path: 'enter-review',
        name: 'EnterReview',
        component: () => import('@/views/Goods/enter-review.vue'),
        meta: {
          title: '录入商品审核',
          icon: 'carbon:skill-level-advanced'
        }
      }
    ]
  },
  {
    path: '/order',
    component: Layout,
    redirect: '/order/account-trade',
    name: 'Order',
    meta: {
      title: '订单管理',
      icon: 'carbon:skill-level-advanced'
    },
    children: [
      {
        path: 'account-trade',
        name: 'AccountTrade',
        component: () => import('@/views/Order/account-trade.vue'),
        meta: {
          title: '账号交易',
          icon: 'carbon:skill-level-advanced'
        }
      },
      {
        path: 'props-trade',
        name: 'PropsTrade',
        component: () => import('@/views/Order/props-trade.vue'),
        meta: {
          title: '道具交易',
          icon: 'carbon:skill-level-advanced'
        }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  strict: true,
  routes: constantRouterMap as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 })
})

export const resetRouter = (): void => {
  const resetWhiteNameList = ['Redirect', 'Login', 'NoFind', 'Root']
  router.getRoutes().forEach((route) => {
    const { name } = route
    if (name && !resetWhiteNameList.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name)
    }
  })
}

export const setupRouter = (app: App<Element>) => {
  app.use(router)
}

export default router
